import {
  Component,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { UserSearchResult } from 'anchor-shared/lib/model/interface/userSearchResult';

@Component({
  selector: 'app-user-search-dialog',
  templateUrl: './user-search-dialog.component.html',
  styleUrls: ['./user-search-dialog.component.scss'],
})
export class UserSearchDialogComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  searchFxn: (string) => Observable<UserSearchResult[]>;
  subs: Subscription[] = [];
  affirmative = false;

  searchText = '';
  foundUsers: UserSearchResult[];
  userType: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UserSearchDialogComponent>,
  ) {}

  ngOnInit() {
    const { searchFxn, userType = 'Users' } = this.data;
    this.searchFxn = searchFxn;
    this.userType = userType;
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe((clicked) => {
      this.dialogRef.close(null);
    });
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  searchClick(): void {
    const sub = this.searchFxn(this.searchText).subscribe((searchResult) => {
      this.foundUsers = searchResult;
    });
    this.subs.push(sub);
  }

  checkClick(userSearchResult: UserSearchResult): void {
    this.dialogRef.close(userSearchResult);
  }
}
